import { useNavigate } from 'react-router-dom';
import { UiButton, UiPageHeader } from '@/ui';

export function AccessDeniedRoute() {
  const navigate = useNavigate();

  return (
    <div className='space-y-4'>
      <UiPageHeader>Permission required</UiPageHeader>
      <p className='text-[#555]'>
        Your current role lacks the permissions needed to view this page. Request access or sign in
        with a different account.
      </p>
      <UiButton variant='primary' onClick={() => navigate('/')}>
        Return home
      </UiButton>
    </div>
  );
}

export function NotFoundRoute() {
  const navigate = useNavigate();

  return (
    <div className='space-y-4'>
      <UiPageHeader>Page not found</UiPageHeader>
      <p className='text-[#555]'>
        The requested route does not exist. Double-check the URL or navigate using the header links.
      </p>
      <UiButton variant='grey' onClick={() => navigate('/')}>
        Go to dashboard
      </UiButton>
    </div>
  );
}
